module.exports = __webpack_public_path__ + "img/full_segmented.07a6bf5d.png";